import { baseURL } from 'settings';

import { api as apiService, ApiService } from './api'
import { IDashboard, IDashboardParams } from 'interfaces/IDashboard';
import { IPunctualityParams, IPunctualityResponse, IPunctualityDetailParams, IPunctualityOrder } from 'interfaces/IPunctuality';
import { DashboardPaginationProps } from 'interfaces/IPagination';
import { IComplaintsResponse, IComplaintsParams, IComplaintsDetailParams, IComplaint } from 'interfaces/IComplaints';
import qs from 'qs';

class DashboardService {
  constructor(private readonly api: ApiService, private readonly baseURL: string) { }

  public getDashboardData = async (params: IDashboardParams): Promise<IDashboard> => {
    return await this.api.get(`${this.baseURL}/v1/dashboard/`, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  };

  // Endpoint principal: resumos de pontualidade por grupo (motorista/time)
  public getPunctualityData = async (params: IPunctualityParams): Promise<DashboardPaginationProps<IPunctualityResponse>> => {
    return await this.api.get(`${this.baseURL}/v1/dashboard/punctuality`, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  }

  // Endpoint de detalhes: pedidos específicos de um grupo com paginação
  public getPunctualityDetail = async (params: IPunctualityDetailParams): Promise<DashboardPaginationProps<IPunctualityOrder>> => {
    return await this.api.get(`${this.baseURL}/v1/dashboard/punctuality/detail`, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  }

  // Endpoint principal: resumos de reclamações por grupo (motorista/time)
  public getComplaintsData = async (params: IComplaintsParams): Promise<DashboardPaginationProps<IComplaintsResponse>> => {
    return await this.api.get(`${this.baseURL}/v1/dashboard/complaint`, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  }

  // Endpoint de detalhes: reclamações específicas de um grupo com paginação
  public getComplaintsDetail = async (params: IComplaintsDetailParams): Promise<DashboardPaginationProps<IComplaint>> => {
    return await this.api.get(`${this.baseURL}/v1/dashboard/complaint/detail`, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  }
}

export const dashboardService = new DashboardService(apiService, baseURL)
